import { formatValue } from "./format_value";

export function barChart(config) {
  const primary = config.datasets[0];
  const secondary = config.datasets[1];

  const datasets = [
    ...(secondary ? [{
      label: secondary.title,
      type: 'line',
      data: alignData(primary.data.labels, secondary.data),
      borderWidth: 0,
      pointStyle: 'triangle',
      rotation: 180,
      pointRadius: 8,
      hoverRadius: 10,
      backgroundColor: '#e34c22'
    }] : []),
    {
      label: primary.title,
      type: 'bar',
      data: primary.data.data,
      borderWidth: 0,
      backgroundColor: '#dfb829',
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.dataset['data'][context.dataIndex];
            if (value === null) {
              return null;
            } else {
              return primary.title + ': ' + formatValue(Number(value), config.options.format, config.options.fractionDigits)
            }
          }
        }
      }
    }
  ];

  return {
    data: {
      labels: primary.data.labels,
      datasets: datasets
    },
    options: {
      indexAxis: 'y',
      locale: 'nl-NL',
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: {
            filter: function(item, chart) {
              // Only show legend items with a non-empty label
              return item.text !== '';
            }
          }
        }
      },
      scales: {
        x: {
          beginAtZero: true,
          ticks: {
            precision: 0,
            callback: function(value) {
              return formatValue(value, config.options.format, config.options.fractionDigits);
            }
          }
        },
        y: {
          ticks: {
            crossAlign: 'far',
          }
        }
      },
      interaction: {
        mode: 'index',
      }
    }
  }
}

/**
 * Aligns a partial data object to a full labels array.
 *
 * @param {Array} labels - Array of all labels (in order)
 * @param {Object} partialData - Object with partial data (label => value)
 * @returns {Array} aligned data array matching label order
 */
function alignData(labels, partialObj) {
  const datamap = Object.fromEntries(partialObj.labels.map((label, i) => [label, partialObj.data[i]]));
  return labels.map(label => (label in datamap ? datamap[label] : null));
}
